//@ts-nocheck
import React, { useEffect } from 'react';
import styled from "styled-components";
import * as d3 from 'd3';
import { gray, blue, green, orange, other, deleteECRReportImage, exportECRChart, filterECRHeading_AndComparison, compareMeasure, createStackedChart_NoComparison, createStackedChart_Comparison } from "./elements/helpers";
import { Heading3, ReportText } from '../../Common/SharedStyledComponents';


const AwardCountChart = ({
    awardCount,
    awardCount_2,
    parentWidth,
    EarlyCareerReportState,
    report_display_id,
    currentDateTime,
    university,
    start_year,
    end_year,
    vintage
}) => {
    useEffect(() => {
        d3.select("#AwardCountChart svg").remove();
        d3.select("#AwardCountChart .ecr_tooltip").remove();
        deleteECRReportImage("award-count-chart.png", currentDateTime, report_display_id, vintage);

        //console.log(awardCount);
        //console.log(awardCount_2);
        const compare_measure = compareMeasure(EarlyCareerReportState.EarlyCareerReportFilterSavedValues);

        if ((compare_measure == 0 && awardCount && awardCount.length > 0) ||
            (compare_measure > 0 && awardCount && awardCount_2 && awardCount.length > 0 && awardCount_2.length > 0)) {
            const subgroups = ["more than 1", "1", "0"];
            const colors = [green, blue, gray]
            //is compare on
            if (compare_measure == 0) {
                createStackedChart_NoComparison(
                    "#AwardCountChart",
                    parentWidth,
                    awardCount,
                    subgroups,
                    "award_bucket",
                    "pct",
                    "Proportion of Faculty",                   
                    colors
                );
            }
            else {
                if (awardCount_2 && awardCount_2.length > 0) {
                    createStackedChart_Comparison(
                        "#AwardCountChart",
                        parentWidth,
                        awardCount,
                        awardCount_2,
                        compare_measure,
                        subgroups,
                        "award_bucket",
                        "pct",
                        "Proportion of Faculty",
                        colors
                    );
                }
            }
            exportECRChart("#AwardCountChart", "award-count-chart.png", EarlyCareerReportState, report_display_id, currentDateTime, "no", vintage)
        }
    }, [awardCount, awardCount_2, parentWidth])
    //console.log(EarlyCareerReportState.EarlyCareerReportFilterSavedValues);
    const subHeading = filterECRHeading_AndComparison(EarlyCareerReportState.EarlyCareerReportFilterSavedValues, EarlyCareerReportState.Suborgs);
    const compare_measure = compareMeasure(EarlyCareerReportState.EarlyCareerReportFilterSavedValues);

    if (compare_measure > 0) {
        //need both awardCount and awardCount_2 to have at least one value per year

        const years = ['1', '2', '3', '4', '5', '6', '7', '8'];
        const filtered1 = awardCount?.filter(function (item) {
            return years.includes(item.t_emp);
        })
        const filtered2 = awardCount_2?.filter(function (item) {
            return years.includes(item.t_emp);
        })

        //console.log(filtered1)
        //console.log(filtered2)
    }

    return (
        <div className="ChartComponent">
            <div id="AwardCountChart_ForExport">
                <Heading3 bold italic>Number of Awards as PIs, {university} Faculty</Heading3>
                <Heading3 italic>{subHeading}</Heading3>
                <div id="AwardCountChart"></div>
                {(awardCount?.length == 0 || (compare_measure > 0 && (awardCount?.length == 0 || awardCount_2?.length == 0))) && <p className="no_data_text">Due to the small number of results and the potential for disclosure of personal information, this chart cannot be displayed. Please select a larger group.</p>}
                <ReportText>
                    This chart shows the number of grants on which faculty members are principal investigators. “Data Year” refers to the number of years a cohort of faculty members has appeared in the IRIS-UMETRICS dataset of researchers paid on sponsored grants. Data from 2002 to 2022 were used to build these cohorts.
                </ReportText>
                {/*(compare_measure > 0) &&
                    (filtered1?.length < 8 || filtered2?.length < 8) &&
                    <p>Note: Insufficient data</p>
                */}
            </div>
            <a className="export" onClick={() => exportECRChart("#AwardCountChart_ForExport", "award-count-chart.png", EarlyCareerReportState, report_display_id, currentDateTime, "yes", vintage)}><i className="fa fas fa-download ecr_export"></i>Export Chart</a>
        </div>
    );
}

/**
 * Styled div to shrink graph titles
 * */
export const TitleDiv = styled.div`
    width: 75%;
    margin-inline: auto;
`;

export default AwardCountChart;